import { render } from "./LoginBox.vue?vue&type=template&id=61a3fd7f&scoped=true&ts=true"
import script from "./LoginBox.vue?vue&type=script&lang=ts"
export * from "./LoginBox.vue?vue&type=script&lang=ts"

import "./LoginBox.vue?vue&type=style&index=0&id=61a3fd7f&lang=less&scoped=true"
import "./LoginBox.vue?vue&type=style&index=1&id=61a3fd7f&lang=less"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61a3fd7f"]])

export default __exports__